<script lang="ts">
  import type { UpdateMenuConfig } from '$lib/models/client/types';
  import { SlideToggle } from '@skeletonlabs/skeleton';

  export let menuConfigs: UpdateMenuConfig[];
</script>

<div class="border-surface-500 rounded-container-token grid grid-cols-1 gap-5 border p-5">
  <div class="text-primary-500 mb-5 text-lg font-bold">User Menu Defaults</div>
  <div class="grid grid-cols-12 items-center font-semibold text-lg text-gray-500 mb-2">
    <div class="col-span-8">Menu</div>
    <div class="col-span-3">Apply to All Users</div>
    <div class="col-span-1 text-center">Enabled</div>
  </div>
  {#each menuConfigs as menuConfig}
    <div class="grid grid-cols-12 items-center">
      <div class="label col-span-8">{menuConfig.name}</div>
      <div class="col-span-3 flex items-center gap-2">
        <input type="checkbox" bind:checked={menuConfig.applyToAllUser} />
        {#if menuConfig.applyToAllUser}
          <span
            class="rounded px-2 py-1 text-xs {menuConfig.enabled
              ? 'bg-success-100 text-success-700 border-success-300 border'
              : 'bg-error-100 text-error-700 border-error-300 border'}"
          >
            {menuConfig.enabled ? 'Add to all users' : 'Remove from all users'}
          </span>
        {/if}
      </div>
      <div class="col-span-1 flex flex-col items-center">
        <SlideToggle name={menuConfig.name} bind:checked={menuConfig.enabled} active="bg-success-500" background="bg-secondary-600" />
      </div>
    </div>
  {/each}
</div>
